import { afterRenderEffect, Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { IAbstractModal } from '@dss-libs/shared/type/common-types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
})
export abstract class AbstractModalComponent<T = unknown> implements IAbstractModal<T> {
  dialogData = inject<T>(MAT_DIALOG_DATA, { optional: true });
  protected readonly dialogRef = inject(MatDialogRef);
  protected readonly router = inject(Router);

  readonly #navigationSignal = toSignal(this.router.events, { initialValue: null });

  readonly navigationEffect = afterRenderEffect(() => {
    if (this.#navigationSignal() instanceof NavigationEnd) {
      this.closeModal();
    }
  });

  protected closeModal(): void {
    this.dialogRef.close();
  }

  protected completeAndCloseModal(): void {
    this.dialogRef.close(true);
  }
}
